@if (showDisclaimer) {
  <lg-modal
    class="disclaimer-popup__modal"
    id="{{ modalSelectorId }}"
    [ngClass]="{ 'is-visible': disclaimerStatusSet }"
  >
    <lg-modal-header class="disclaimer-popup__header">
      @if (logo) {
        <div class="disclaimer-popup__logo">
          <dotcom-frontend-image [image]="logo"></dotcom-frontend-image>
        </div>
      }

      @if (disclaimerTitle) {
        <div
          [innerHTML]="disclaimerTitle | safeHtml"
          class="disclaimer-popup__title"
        ></div>
      }
    </lg-modal-header>
    <lg-modal-body>
      @if (secondaryTabTitle) {
        <lg-tabs label="disclaimer-tabs">
          @if (termsAndConditions) {
            <lg-tab-item>
              <lg-tab-item-heading>{{ primaryTabTitle }}</lg-tab-item-heading>
              <lg-tab-item-content>
                <ng-container [ngTemplateOutlet]="terms" />
              </lg-tab-item-content>
            </lg-tab-item>
          }

          @if (secondaryTab) {
            <lg-tab-item>
              <lg-tab-item-heading>{{ secondaryTabTitle }}</lg-tab-item-heading>
              <lg-tab-item-content>
                @for (component of secondaryTab; let i = $index; track i) {
                  <dotcom-frontend-loader
                    [componentData]="component"
                    parent="disclaimer"
                  />
                }
              </lg-tab-item-content>
            </lg-tab-item>
          }
        </lg-tabs>
      } @else if (termsAndConditions) {
        <ng-container [ngTemplateOutlet]="terms" />
      }
    </lg-modal-body>

    <lg-modal-footer>
      <div class="disclaimer-popup__buttons">
        @if (acceptButtonLabel) {
          <button
            (click)="
              onAccept(modalSelectorId);
              interactionClickEvent('/', acceptButtonLabel);
              setDisclaimerCookie(blockId)
            "
            [disabled]="hasCheckbox && !checkboxChecked"
            [class.disabled]="hasCheckbox && !checkboxChecked"
            class="disclaimer-popup__accept-button"
            lg-button
          >
            {{ acceptButtonLabel }}
          </button>
        }

        @if (declineButtons) {
          @for (button of declineButtons; let i = $index; track i) {
            <dotcom-frontend-loader
              [componentData]="button"
              cssClass="disclaimer-popup__decline-button"
            />
          }
        }
      </div>
    </lg-modal-footer>
  </lg-modal>
}

<ng-template #terms>
  @if (disclaimerIntro) {
    <div
      [innerHTML]="disclaimerIntro | safeHtml"
      class="disclaimer-popup__intro"
    ></div>
  }

  <div
    [innerHTML]="termsAndConditions | safeHtml"
    class="disclaimer-popup__terms-and-conditions-scrollable"
    aria-label="Terms and Conditions"
    role="region"
    tabindex="0"
  ></div>

  @if (checkboxText) {
    <div class="disclaimer-popup__checkbox">
      <lg-toggle
        (change)="onCheckboxChange($event)"
        name="confirm"
        size="lg"
        value="false"
      >
        {{ checkboxText }}
      </lg-toggle>
    </div>
  }
</ng-template>
